import { Directive, HostListener, EventEmitter, Output, ElementRef, Renderer2 } from '@angular/core';

@Directive({
    selector: '[pick-file]'
})
export class PickFileDirective {
    @Output() private filesChangeEmiter: EventEmitter<any> = new EventEmitter();

    input: any;

    constructor(private el: ElementRef,
                private renderer: Renderer2) {
    }

    @HostListener('click')
    browse() {
        if (!this.input) {
            console.error('It seems that ngOnInit() has not been executed or that the hidden input element is null. Did you mess with the DOM?');
            return;
        }
        this.input.click();
    }

    ngOnInit() {
        console.log('pickFileInited')
        this.input = this.renderer.createElement('input');
        this.renderer.appendChild(this.el.nativeElement, this.input);
        this.renderer.setAttribute(this.input, 'type', 'file');
        this.renderer.setAttribute(this.input, 'accept', 'img');//you can change img for any input type or even add an @input);
        this.renderer.setStyle(this.input, 'display', 'none');
        this.renderer.listen(this.input, 'change', (event: any) => {
            const selectedFile = event.target.files[0]
            this.getBase64(selectedFile).then((res) => {
                this.filesChangeEmiter.emit(res);
            }).catch((err) => {
                console.log(err);
            })
        });
    }

    getBase64(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    }
}


// WEBPACK FOOTER //
// ./src/directives/drop-file/pick-file.ts